import React from 'react'
import './css/dashboard.css'
import Metrics from './Metrics/Metrics'
import KeyMetrics from './KeyMetrics/KeyMetrics'
import ConnectorPanel from './ConnectorPanel/ConnectorPanel'

const Dashboard = () => (
    <div className="main-content mn-dashboard">
        <div className="page-content custompaddingdash">
            <div className="container-fluid">
                <Metrics />
                <KeyMetrics />
                <ConnectorPanel />
            </div>
        </div>
    </div>
)

export default Dashboard
